import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveAddressType, saveAddressTypePublic } from "./index";

// Api's
import { addressTypeApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getAddressTypeSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(addressTypeApi.getDomain);

		if (response.data.result) {
			yield put(saveAddressType(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveAddressType(null, true, resultError.messagesDataError));
		}
	}
}
export function* getAddressTypePublicSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(addressTypeApi.getDomain);

		if (response.data.result) {
			yield put(saveAddressTypePublic(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveAddressTypePublic(null, true, resultError.messagesDataError));
		}
	}
}
